import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useNavigate } from "react-router-dom";

export default function ShotCard(props) {
  const navigate = useNavigate();
  const item = props.shotInfo;

  const seeMoreInfo = () => {
    navigate(`/shots/${item["3-Pointer Number"]}`);
  };
  return (
    <Card sx={{ minWidth: 150 }}>
      <CardContent>
        <Typography variant="h5" component="div">
          #{item["3-Pointer Number"]}
        </Typography>
        <Typography color="body2">
          {item.Month}/{item.Day}/{item.Year}
        </Typography>
        <Typography variant="body2">
          {item.VTM}@{item.HTM}
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="body2">
          Q{item.PERIOD} {item.MINUTES_REMAINING}:{item.SECONDS_REMAINING.toString().length === 2? item.SECONDS_REMAINING : '0'+item.SECONDS_REMAINING}
        </Typography> 
        <Typography variant="body2" color="text.secondary">
          {item.SHOT_DISTANCE} ft
        </Typography>
        <Typography variant="body2" color="text.secondary">
            {item["3-Pointers made in the game"]} in game
        </Typography>
        <Button size="small" onClick={seeMoreInfo} sx={{marginTop: '10px'}}>More info</Button>
      </CardContent>
    </Card>
  );
}